export default {
  student: {},
  students: [],
  directions: [],
}
